const URL_SUBSCRIPTIONS = "https://com-surpnorm-senseev.appspot.com/v1/subscriptions";
//const URL_SUBSCRIPTION = "http://localhost:8080/v1/subscriptions";

class SubscriptionsApi {

  static requestHeaders(deviceId, authToken) {
    return {'Authorization': `Bearer deviceId="${deviceId}",authenticationToken="${authToken}"`}
  }

  static getSubscriptions(deviceId, authToken) {
    const headers = this.requestHeaders(deviceId, authToken);
    const request = new Request(`${URL_SUBSCRIPTIONS}/`, {
      method: 'GET',
      headers: headers
    });

    return fetch(request).then(response => {
		return response.json().then(json => {
			return json;
		});
    }).catch(error => {
      return error;
    });
  }

  static createSubscriptions(deviceId, authToken, stripeCustomerEmail, stripeTokenId, couponCode, products) {
	var params = {stripeCustomerEmail: stripeCustomerEmail, stripeTokenId: stripeTokenId, products: products};
	if (couponCode != null && couponCode != '') {
		params["couponCode"] = couponCode;
	}
	
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/stripe`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(params)
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }

  static updateCardDetails(deviceId, authToken, stripeCustomerEmail, stripeTokenId) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/stripe`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({stripeCustomerEmail: stripeCustomerEmail, stripeTokenId: stripeTokenId})
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }

  static addProducts(deviceId, authToken, products) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/stripe`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({action: "add", products: products})
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }

  static removeProducts(deviceId, authToken, products) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/stripe`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({action: "remove", products: products})
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }

  static cancelSubscriptions(deviceId, authToken) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/stripe`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({action: "cancel"})
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }

  static reactivateSubscriptions(deviceId, authToken) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/stripe`, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify({action: "activate"})
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }
  
  static subscribeSubscriptions(deviceId, authToken, firebaseInstanceIdToken) {
    const headers = Object.assign({'Content-Type': 'application/json'}, this.requestHeaders(deviceId, authToken));
    const request = new Request(`${URL_SUBSCRIPTIONS}/subscriptions/${firebaseInstanceIdToken}`, {
      method: 'PUT', 
      headers: headers
    });

    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    });
  }
}

export default SubscriptionsApi;


// WEBPACK FOOTER //
// ./src/api/subscriptionsApi.js